/* OS Conference Table Size Calculator (build chat #34, 2026-09-17, v3 after John's round 2: bubble answer, rect-first pick, credenza question).
   Browser port of scripts/os-website-build/conference-calc-rules.mjs. Keep the two in step:
   scripts/os-website-build/conference-calc-parity.mjs runs both on the same inputs and fails on any difference.
   Rules and sources: outputs/research/conference-table-size-rules-2026-09-17.md
   No network calls. Data comes from the inline JSON the section renders.
   2026-10-23 (John): a "Shop N ft conference tables" button in the answer (the conference page with that length selected) and
   two site-tracker events, calc_answer and calc_shop (window.osTrack), so the analytics page can tell use from a bounce.
   Based on the LIVE file of 2026-09-17, not the repo's main (which carries the unpublished #44 ready-to-ship nudge). */
(function () {
  'use strict';

  var RULES = {
    clearance: { tight: 36, standard: 48, generous: 60 },
    tierOrder: ['generous', 'standard', 'tight'],
    defaultClearance: 'standard',
    tierNames: { tight: 'Tight', standard: 'Comfortable', generous: 'Roomy' },
    chairDepth: 24,
    seatComfort: 30,
    seatBoard: 24,
    endSeatMinWidth: 42,
    credenzaDepth: 24,
    minRoomFt: 8, maxRoomFt: 80,
    minPeople: 2, maxPeople: 30,
    customPairs: { 72: [36], 84: [42, 48], 96: [42, 48], 120: [48, 54, 60], 144: [48, 54, 60], 168: [48, 54, 60], 192: [48, 54, 60], 216: [48, 54, 60], 240: [48, 54, 60] },
    bundledCredenza: ['conference-table-with-credenza', 'huge-conference-table']
  };
  var CUSTOM_LENGTHS = Object.keys(RULES.customPairs).map(Number).sort(function (a, b) { return a - b; });
  var MAX_WIDTH = 60;

  function ft(inches) { var f = Math.floor(inches / 12), r = inches % 12; return f + ' ft' + (r ? ' ' + r + ' in' : ''); }
  function roundFt(inches, tier) { return (tier === 'tight' ? Math.floor(inches / 12) : Math.round(inches / 12)) + ' ft'; }
  function an(s) { return (/^(8|11|18|80)\b/.test(s) ? 'an' : 'a') + ' ' + s; }
  function pieces(L) { return L <= 96 ? 'one piece' : L <= 192 ? 'two sections' : 'three sections'; }
  function seatsRect(L, W, spacing, countEnds) { var perSide = Math.floor(L / spacing); var ends = countEnds && W >= RULES.endSeatMinWidth ? 2 : 0; return perSide * 2 + ends; }
  function seatsRound(d, spacing) { return Math.floor((Math.PI * d) / spacing); }
  function seatPair(p) {
    var c = p.shape === 'round' ? seatsRound(p.w, RULES.seatComfort) : seatsRect(p.w, p.l, RULES.seatComfort, true);
    var b = p.shape === 'round' ? seatsRound(p.w, RULES.seatBoard) : seatsRect(p.w, p.l, RULES.seatBoard, false);
    return { comfort: c, board: Math.max(c, b) };
  }
  function lengthForSeats(N, spacing, countEnds) { var ends = countEnds ? 2 : 0; var side = Math.max(0, N - ends); return Math.max(36, Math.ceil(side / 2) * spacing); }

  function core(input, catalog, tier, credenzaWall) {
    var people = input.people || null;
    var clr = RULES.clearance[tier];
    var roomL = Math.round(Math.max(input.roomLengthFt, input.roomWidthFt) * 12);
    var roomW = Math.round(Math.min(input.roomLengthFt, input.roomWidthFt) * 12);
    var out = { input: input, tier: tier, credenzaWall: credenzaWall, steps: [] };
    var takeL = credenzaWall === 'short' ? RULES.credenzaDepth : 0;
    var takeW = credenzaWall === 'long' ? RULES.credenzaDepth : 0;
    var maxL = roomL - takeL - 2 * clr;
    var maxW = roomW - takeW - 2 * clr;
    out.steps.push('Room ' + ft(roomL) + ' x ' + ft(roomW) + ' = ' + roomL + ' x ' + roomW + ' in.');
    out.steps.push('Clearance ' + clr + ' in on every side. Longest table: ' + roomL + (takeL ? ' - ' + takeL + ' (credenza on the end wall)' : '') + ' - ' + clr + ' - ' + clr + ' = ' + maxL + ' in.');
    out.steps.push('Widest table: ' + roomW + (takeW ? ' - ' + takeW + ' (credenza on the long wall)' : '') + ' - ' + clr + ' - ' + clr + ' = ' + maxW + ' in.');
    out.room = { maxL: maxL, maxW: maxW, clr: clr, maxWNoCredenza: roomW - 2 * clr, maxLNoCredenza: roomL - 2 * clr };
    var needComfort = people ? lengthForSeats(people, RULES.seatComfort, true) : null;
    var needBoard = people ? Math.min(needComfort, lengthForSeats(people, RULES.seatBoard, false)) : null;
    if (people) { var perSide = Math.ceil(Math.max(0, people - 2) / 2), boardSide = Math.ceil(people / 2); out.steps.push(people + ' people with laptop room: ' + perSide + ' per side at ' + RULES.seatComfort + ' in plus one at each end = ' + needComfort + ' in long. Shoulder to shoulder: ' + boardSide + ' per side at ' + RULES.seatBoard + ' in = ' + needBoard + ' in.'); }
    out.people = people ? { needComfort: needComfort, needBoard: needBoard } : null;
    out.binding = people ? (maxL < needComfort ? 'room' : 'people') : 'room-only';
    function fitsRoom(p) {
      var w = RULES.bundledCredenza.indexOf(p.h) > -1 && credenzaWall !== 'long' ? maxW - RULES.credenzaDepth : maxW;
      return p.w && p.l && p.w <= maxL && p.l <= w;
    }
    var all = [], video = [];
    for (var i = 0; i < catalog.length; i++) {
      var p = catalog[i];
      if (!fitsRoom(p)) continue;
      if (p.shape === 'd') { video.push(p); continue; }
      var sp = seatPair(p); var q = {}; for (var k in p) q[k] = p[k]; q.comfort = sp.comfort; q.board = sp.board; all.push(q);
    }
    out.videoOptions = video;
    var byLen = function (a, b) { return (a.w - b.w) || ((a.p || 0) - (b.p || 0)); };
    var rated = people ? all.filter(function (p) { return p.board >= people; }).sort(byLen) : [];
    var rec = null;
    if (people) { if (people >= 5) { for (var ri = 0; ri < rated.length; ri++) if (rated[ri].shape === 'rect') { rec = rated[ri]; break; } } if (!rec) rec = rated[0] || null; }
    var up = people ? (all.filter(function (p) { return p.comfort >= people && (people < 5 || p.shape === 'rect'); }).sort(byLen)[0] || null) : null;
    out.recommended = rec;
    out.upsize = up && rec && up.w > rec.w ? up : null;
    out.largestFit = all.slice().sort(function (a, b) { return b.w - a.w; })[0] || null;
    out.alternatives = rec ? all.filter(function (p) { return p.w === rec.w && p.h !== rec.h; }) : [];
    var lens = {}; all.forEach(function (p) { lens[p.w] = true; });
    var customLen = null;
    if (people && !up) for (var j = 0; j < CUSTOM_LENGTHS.length; j++) { var l = CUSTOM_LENGTHS[j]; if (l >= needComfort && l <= maxL && !lens[l]) { customLen = l; break; } }
    var customWidths = customLen ? RULES.customPairs[customLen].filter(function (w) { return w <= maxW; }) : [];
    out.custom = customLen && customWidths.length ? { length: customLen, widths: customWidths } : null;
    out.smallerCustom = null;
    if (rec && rec.shape === 'rect' && rec.w > needComfort) for (var m = 0; m < CUSTOM_LENGTHS.length; m++) { if (CUSTOM_LENGTHS[m] >= needComfort && CUSTOM_LENGTHS[m] < rec.w) { out.smallerCustom = CUSTOM_LENGTHS[m]; break; } }
    out.tightFit = rec ? ((maxL - rec.w) < 12 || (maxW - rec.l) < 6) : false;
    out.fitsAll = all.slice().sort(function (a, b) { return (b.w - a.w) || (a.l - b.l); }).slice(0, 8);
    out.fitsMore = all.length - out.fitsAll.length;
    out.verdict = out.largestFit ? 'ok' : 'none';
    return out;
  }

  function compute(input, catalog) {
    var tier0 = input.clearanceTier || RULES.defaultClearance;
    function bad(reason) { return { input: input, verdict: 'contact', reason: reason }; }
    if (!(input.roomLengthFt >= RULES.minRoomFt && input.roomLengthFt <= RULES.maxRoomFt && input.roomWidthFt >= RULES.minRoomFt && input.roomWidthFt <= RULES.maxRoomFt)) return bad('room size outside the rules');
    if (input.people && !(input.people >= RULES.minPeople && input.people <= RULES.maxPeople)) return bad('headcount outside the rules');
    var tiers = RULES.tierOrder.slice(RULES.tierOrder.indexOf(tier0));
    var walls = input.credenza ? ['long', 'short'] : [null];
    var first = null;
    for (var t = 0; t < tiers.length; t++) for (var w = 0; w < walls.length; w++) {
      var r = core(input, catalog, tiers[t], walls[w]);
      if (!first) first = r;
      if (r.verdict === 'ok') { r.requestedTier = tier0; r.fellBack = tiers[t] !== tier0; r.movedCredenza = !!input.credenza && walls[w] === 'short'; return r; }
    }
    first.verdict = 'contact';
    first.reason = 'no table in our range fits this room' + (input.credenza ? ' with a credenza' : '') + ', even at ' + RULES.clearance.tight + ' in of clearance';
    return first;
  }

  // ---------- headline (the bubble) ----------
  function sizeName(p) { return p.shape === 'round' ? p.w + ' in round table' : (p.w < 60 ? p.w + ' in square table' : ft(p.w) + ' table'); }
  function headline(r) {
    if (r.verdict === 'contact') return "We can't size this room from the numbers given.";
    if (r.binding === 'room-only') return 'Your room fits up to ' + an(sizeName(r.largestFit)) + '.';
    if (!r.recommended) return 'No table in our range seats ' + r.input.people + ' in this room.';
    return 'We recommend ' + an(sizeName(r.recommended)) + '.';
  }
  function whyLine(r) {
    if (r.binding === 'room-only' || !r.recommended) return null;
    var maxL = r.room.maxL, i = r.input;
    if (r.binding === 'room') return 'Your room is the limit: up to ' + roundFt(maxL, r.tier) + ' long.';
    var need = r.people.needComfort;
    if (need < maxL) return 'Your room fits up to ' + roundFt(maxL, r.tier) + ', but ' + i.people + ' people only need ' + ft(need) + '.';
    return 'Your room fits up to ' + roundFt(maxL, r.tier) + ', which is what ' + i.people + ' people need.';
  }

  // ---------- text lines (identical wording to the Node engine's render()) ----------
  function seatsText(p) { return p.comfort === p.board ? 'seats ' + p.comfort : 'seats ' + p.comfort + ' with laptop room, up to ' + p.board + ' shoulder to shoulder'; }
  function nameText(p) { return p.t + ' (' + p.w + ' x ' + p.l + ' in)'; }
  function lines(r) {
    var i = r.input, L = [];
    if (r.verdict === 'contact') { L.push({ k: 'contact', text: "We can't size this from the numbers given (" + r.reason + '). Measure the room and contact us.' }); return L; }
    var maxL = r.room.maxL, maxW = r.room.maxW, clr = r.room.clr;
    var widthText = maxW >= MAX_WIDTH ? 'any width we build (up to ' + MAX_WIDTH + ' in) fits' : 'up to ' + roundFt(maxW, r.tier) + ' wide';
    var pre = '';
    if (r.fellBack) pre = 'Nothing in our range fits with ' + RULES.clearance[r.requestedTier] + ' in of clearance' + (i.credenza ? ' and the credenza' : '') + '. With ' + clr + ' in (' + (r.tier === 'tight' ? 'chairs pull out, nobody walks behind a seated person' : 'a pulled-out chair plus room to pass behind it') + ')' + (r.movedCredenza ? ' and the credenza on the short end wall' : '') + ': ';
    else if (r.movedCredenza) pre = 'Nothing fits with the credenza on the long wall. With the credenza on the short end wall instead: ';
    L.push({ k: 'room', text: pre + 'Your room fits a table up to ' + roundFt(maxL, r.tier) + ' long, ' + widthText + '.' });
    L.push({ k: 'headline', text: 'HEADLINE: ' + headline(r) + (whyLine(r) ? ' ' + whyLine(r) : ''), head: headline(r), why: whyLine(r) });
    if (i.credenza && r.credenzaWall === 'long' && maxW < MAX_WIDTH) L.push({ k: 'credenza', text: 'The credenza takes ' + RULES.credenzaDepth + ' in off the room width: widest table ' + ft(maxW) + ' instead of ' + (r.room.maxWNoCredenza >= MAX_WIDTH ? 'any width we build' : ft(r.room.maxWNoCredenza)) + '.' });
    if (i.credenza && r.credenzaWall === 'short') L.push({ k: 'credenza', text: 'The credenza on the end wall takes ' + RULES.credenzaDepth + ' in off the room length: longest table ' + ft(maxL) + ' instead of ' + ft(r.room.maxLNoCredenza) + '.' });
    if (i.credenza && r.credenzaWall === 'long' && maxW >= MAX_WIDTH) L.push({ k: 'credenza', text: 'The credenza fits with room to spare: any width we build still fits beside it.' });
    if (r.binding === 'room-only') {
      L.push({ k: 'fits', text: 'Tables that fit:', items: r.fitsAll, withSeats: true, more: r.fitsMore });
      L.push({ k: 'hint', text: 'Add your headcount and we narrow it to one.' });
      L.push({ k: 'math', text: 'The math: ' + r.steps.join(' ') });
      return L;
    }
    if (r.binding === 'room') L.push({ k: 'bind', text: 'Your room is the limit. ' + i.people + ' people would like ' + ft(r.people.needComfort) + ' with laptop room; the room allows ' + roundFt(maxL, r.tier) + '.' });
    else L.push({ k: 'bind', text: 'Your headcount is the limit. ' + i.people + ' people need ' + ft(r.people.needComfort) + ' with laptop room' + (r.people.needBoard < r.people.needComfort ? ' (' + ft(r.people.needBoard) + ' shoulder to shoulder)' : '') + '; the room would take up to ' + roundFt(maxL, r.tier) + '.' });
    if (r.recommended) {
      var p = r.recommended;
      L.push({ k: 'rec', text: 'Fits your headcount: ' + nameText(p) + ' ' + seatsText(p) + '.', link: p });
      if (p.shape === 'rect' && p.w >= 96) L.push({ k: 'pieces', text: 'Arrives in ' + pieces(p.w) + (p.w > 96 ? '; the grain will not line up at the seam.' : '; a ' + p.w + ' x ' + p.l + ' in top has to get through the door and any turns.') });
      if (r.alternatives.length) L.push({ k: 'alt', text: 'Also at this length:', items: r.alternatives });
      if (r.upsize) L.push({ k: 'up', text: 'For laptop room for all ' + i.people + ': ' + nameText(r.upsize) + ' ' + seatsText(r.upsize) + '.', link: r.upsize });
      if (r.smallerCustom) L.push({ k: 'why', text: 'Why ' + ft(p.w) + ': it is the shortest rectangular table we make as standard. ' + an(ft(r.smallerCustom)) + ' top is built to order if you want the exact fit (custom sizes are final sale).', custom: true });
      if (r.tightFit) L.push({ k: 'tight', text: 'Note: this is an exact fit. Center the table; there is no margin on the tight side.' });
      var set = null;
      if (i.credenza) { var pool = [p].concat(r.alternatives); for (var si = 0; si < pool.length; si++) if (RULES.bundledCredenza.indexOf(pool[si].h) > -1) { set = pool[si]; break; } }
      if (set) L.push({ k: 'set', text: 'Want the credenza included? ' + nameText(set) + ' comes with a ' + RULES.credenzaDepth + ' in deep credenza.', link: set });
    } else {
      L.push({ k: 'none', text: 'No table in our range seats ' + i.people + ' in this room. Largest that fits: ' + nameText(r.largestFit) + ', ' + seatsText(r.largestFit) + '.', link: r.largestFit });
    }
    if (r.largestFit && r.recommended && r.largestFit.h !== r.recommended.h && (!r.upsize || r.upsize.h !== r.largestFit.h)) L.push({ k: 'largest', text: 'Largest that fits: ' + nameText(r.largestFit) + '.', link: r.largestFit });
    if (r.custom) L.push({ k: 'custom', text: 'Custom: ' + an(ft(r.custom.length)) + ' x ' + r.custom.widths[r.custom.widths.length - 1] + ' in top is built to order and seats ' + i.people + ' with laptop room (widths ' + r.custom.widths.join(', ') + '; custom sizes are final sale; arrives in ' + pieces(r.custom.length) + (r.custom.length > 96 ? ', grain will not line up at the seam' : '') + ').', custom: true });
    if (i.people <= 6 && r.videoOptions.length) L.push({ k: 'video', text: 'For a video room:', items: r.videoOptions.map(function (p) { var q = {}; for (var k in p) q[k] = p[k]; q.t = p.t + ' (' + p.w + ' x ' + p.l + ' in, ' + (p.ht >= 36 ? 'counter height, stools' : 'desk height') + ')'; q.bare = true; return q; }) });
    L.push({ k: 'math', text: 'The math: ' + r.steps.join(' ') });
    return L;
  }

  // plain-text rendering (parity with the Node engine)
  function renderText(r) {
    var i = r.input;
    var out = ['INPUT: room ' + i.roomLengthFt + ' x ' + i.roomWidthFt + ' ft, ' + (i.people || 'no') + ' people, credenza ' + (i.credenza ? 'yes' : 'no') + ', clearance ' + (i.clearanceTier || RULES.defaultClearance)];
    var ls = lines(r);
    for (var n = 0; n < ls.length; n++) {
      var l = ls[n], pref = n === 0 ? 'OUTPUT: ' : '  ';
      if (l.k === 'rec' || l.k === 'up' || l.k === 'set') out.push(pref + l.text + ' ' + l.link.u);
      else if (l.items) out.push(pref + l.text + ' ' + l.items.map(function (p) { return p.bare ? p.t : (nameText(p) + (l.withSeats ? ' ' + seatsText(p) : '')); }).join('; ') + (l.more > 0 ? '; and ' + l.more + ' more' : '') + '.');
      else out.push(pref + l.text);
    }
    return out.join('\n');
  }

  // ---------- "Shop N ft conference tables" (John 2026-10-23) ----------
  // The conference page (/collections/conference-tables?size=N) has size buttons for 8, 10, 12, 14, 16, 18 and 20 ft.
  // The pick's length when it is one of those (room-only answers: the largest that fits); round and other lengths: no button.
  var SHOP_SIZES = [8, 10, 12, 14, 16, 18, 20];
  function shopLength(r) {
    if (!r || r.verdict !== 'ok') return null;
    var p = r.recommended || (r.binding === 'room-only' ? r.largestFit : null);
    if (!p || p.shape !== 'rect' || !p.w) return null;
    var f = Math.round(p.w / 12);
    return SHOP_SIZES.indexOf(f) > -1 ? f : null;
  }
  function osTrack(name, fields) { try { if (window.osTrack) window.osTrack(name, fields); } catch (e) {} }

  // ---------- DOM ----------
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function link(p) { var a = el('a', 'os-calc__link', p.t); a.href = p.u; return a; }
  function productItem(p, withSeats) {
    var li = el('li', 'os-calc__pick');
    li.appendChild(link(p));
    li.appendChild(document.createTextNode(' ' + p.w + ' x ' + p.l + ' in' + (withSeats ? ', ' + seatsText(p) : '')));
    return li;
  }

  function renderDom(root, r, contactUrl) {
    root.innerHTML = '';
    var ls = lines(r);
    if (r.verdict === 'contact') {
      var bub0 = el('div', 'os-calc__bubble'); bub0.appendChild(el('p', 'os-calc__bubble-head', headline(r)));
      var c = el('p', 'os-calc__line os-calc__line--contact', ls[0].text + ' ');
      var a = el('a', 'os-calc__link', 'Contact us'); a.href = contactUrl; c.appendChild(a); root.appendChild(bub0); root.appendChild(c); return;
    }
    // 1. the bubble: headline + why + (for a pick) seats
    var bub = el('div', 'os-calc__bubble');
    bub.appendChild(el('p', 'os-calc__bubble-head', headline(r)));
    var why = whyLine(r); if (why) bub.appendChild(el('p', 'os-calc__bubble-why', why));
    if (r.fellBack) bub.appendChild(el('p', 'os-calc__bubble-note', 'Nothing fits with ' + RULES.clearance[r.requestedTier] + ' in of space around the table, so this answer uses ' + r.room.clr + ' in' + (r.movedCredenza ? ' and puts the credenza on the short end wall' : '') + '.'));
    else if (r.movedCredenza) bub.appendChild(el('p', 'os-calc__bubble-note', 'Nothing fits with the credenza on the long wall, so this answer puts it on the short end wall.'));
    if (r.recommended) bub.appendChild(el('p', 'os-calc__bubble-seats', (r.recommended.comfort === r.recommended.board ? 'Seats ' + r.recommended.comfort : 'Seats ' + r.recommended.comfort + ' with laptop room, up to ' + r.recommended.board + ' board style') + '.'));
    var shopFt = shopLength(r);
    if (shopFt) { var sb = el('a', 'os-calc__button os-calc__button--rust os-calc__shop', 'Shop ' + shopFt + ' ft conference tables'); sb.href = '/collections/conference-tables?size=' + shopFt; sb.setAttribute('data-os-calc-shop', String(shopFt)); sb.style.marginTop = '12px'; bub.appendChild(sb); }
    root.appendChild(bub);
    // 2. tables that fit: pick + also + upsize + credenza set (or the room-only list)
    var picks = [];
    for (var n = 0; n < ls.length; n++) {
      var l = ls[n];
      if (l.k === 'rec') picks.push({ p: l.link, tag: 'Our pick' });
      if (l.k === 'alt') for (var q = 0; q < l.items.length; q++) picks.push({ p: l.items[q], tag: 'Same length' });
      if (l.k === 'up') picks.push({ p: l.link, tag: 'Laptop room for all ' + r.input.people });
      if (l.k === 'set') picks.push({ p: l.link, tag: 'Includes a credenza' });
      if (l.k === 'largest') picks.push({ p: l.link, tag: 'Largest that fits' });
      if (l.k === 'none') picks.push({ p: l.link, tag: 'Largest that fits' });
      if (l.k === 'fits') for (var f = 0; f < l.items.length; f++) picks.push({ p: l.items[f], tag: '' });
    }
    if (picks.length) {
      root.appendChild(el('p', 'os-calc__sub', r.binding === 'room-only' ? 'Tables that fit your room' : 'Tables that fit what you are looking for'));
      var ul = el('ul', 'os-calc__picks');
      for (var k = 0; k < picks.length; k++) {
        var pk = picks[k], li = el('li', 'os-calc__pick');
        if (pk.p.img) { var th = el('a', 'os-calc__thumb'); th.href = pk.p.u; th.tabIndex = -1; th.setAttribute('aria-hidden', 'true'); var im = document.createElement('img'); im.src = pk.p.img; im.alt = ''; im.loading = 'lazy'; im.width = 72; im.height = 72; th.appendChild(im); li.appendChild(th); }
        var body = el('div', 'os-calc__pick-body');
        if (pk.tag) body.appendChild(el('span', 'os-calc__tag', pk.tag));
        body.appendChild(link(pk.p));
        body.appendChild(document.createTextNode(' ' + pk.p.w + ' x ' + pk.p.l + ' in, ' + seatsText(pk.p) + '.'));
        li.appendChild(body);
        ul.appendChild(li);
      }
      root.appendChild(ul);
      if (r.binding === 'room-only' && r.fitsMore > 0) root.appendChild(el('p', 'os-calc__line os-calc__line--hint', 'And ' + r.fitsMore + ' more. Add your headcount and we narrow it down.'));
    }
    // 3. the small print: room, credenza effect, pieces, why-8-ft, exact fit, custom, video, math
    for (var m = 0; m < ls.length; m++) {
      var t = ls[m];
      if (['headline', 'rec', 'alt', 'up', 'set', 'largest', 'none', 'fits', 'hint', 'bind'].indexOf(t.k) > -1) continue;
      var pl = el('p', 'os-calc__line os-calc__line--' + t.k);
      if (t.k === 'video') {
        pl.appendChild(document.createTextNode(t.text + ' '));
        for (var v = 0; v < t.items.length; v++) { if (v) pl.appendChild(document.createTextNode('; ')); var av = el('a', 'os-calc__link', t.items[v].t); av.href = t.items[v].u; pl.appendChild(av); }
        pl.appendChild(document.createTextNode('.'));
      } else if (t.custom) {
        pl.appendChild(document.createTextNode(t.text + ' ')); var ac = el('a', 'os-calc__link', 'Ask about a custom size'); ac.href = contactUrl; pl.appendChild(ac); pl.appendChild(document.createTextNode('.'));
      } else pl.textContent = t.text;
      root.appendChild(pl);
    }
  }

  // ---------- usage log (John, round 5): one beacon per answer and per click on a table in the answer ----------
  function visitorId() {
    try { var k = 'os_calc_vid', v = localStorage.getItem(k); if (!v) { v = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); localStorage.setItem(k, v); } return v; } catch (e) { return 'na'; }
  }
  function sendLog(url, payload) {
    if (!url) return;
    try {
      // text/plain keeps the request "simple" (no CORS preflight); the webhook parses the JSON string
      // fetch with no credentials and text/plain = a simple cross-origin request: no preflight, no cookie rules.
      // (sendBeacon always sends credentials, which the webhook does not allow.)
      var body = JSON.stringify(payload);
      if (window.fetch) { fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true, mode: 'cors', credentials: 'omit' }).catch(function () {}); return; }
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
    } catch (e) {}
  }

  function init(section) {
    var dataEl = section.querySelector('script[type="application/json"][data-os-calc-data]');
    if (!dataEl) return;
    var catalog = JSON.parse(dataEl.textContent).products;
    var form = section.querySelector('form[data-os-calc-form]');
    var dialog = section.querySelector('dialog[data-os-calc-dialog]');
    var out = section.querySelector('[data-os-calc-result]');
    var contactUrl = section.getAttribute('data-contact-url') || '/pages/contact';
    var logUrl = section.getAttribute('data-log-url') || '';
    var placement = section.getAttribute('data-placement') || 'page';
    var last = null;
    function num(name) { var f = form.elements[name]; var v = f && f.value !== '' ? Number(f.value) : 0; return isFinite(v) ? v : 0; }
    function tier() { var r = form.querySelector('input[name="clearance"]:checked'); return r ? r.value : RULES.defaultClearance; }
    function open() {
      if (dialog && typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); dialog.scrollTop = 0; }
      else if (dialog) dialog.setAttribute('open', '');
    }
    function run(e) {
      if (e) e.preventDefault();
      var people = num('people');
      var input = {
        roomLengthFt: Math.round(num('length_ft') * 12 + num('length_in')) / 12,
        roomWidthFt: Math.round(num('width_ft') * 12 + num('width_in')) / 12,
        people: people ? Math.min(RULES.maxPeople, people + (form.elements.growth && form.elements.growth.checked ? 2 : 0)) : null,
        credenza: (function () { var c = form.querySelector('input[name="credenza"]:checked'); return !!(c && c.value === '1'); })(),
        clearanceTier: tier()
      };
      last = compute(input, catalog);
      renderDom(out, last, contactUrl);
      open();
      sendLog(logUrl, {
        event: 'answer', placement: placement, path: location.pathname, vid: visitorId(), ts: new Date().toISOString(),
        room_l_ft: input.roomLengthFt, room_w_ft: input.roomWidthFt, people: input.people, credenza: input.credenza, space: input.clearanceTier, growth: !!(form.elements.growth && form.elements.growth.checked),
        verdict: last.verdict, headline: headline(last), why: whyLine(last), pick: last.recommended ? last.recommended.h : null, upsize: last.upsize ? last.upsize.h : null,
        max_l_in: last.room ? last.room.maxL : null, max_w_in: last.room ? last.room.maxW : null, tier_used: last.tier || null, fell_back: !!last.fellBack
      });
      osTrack('calc_answer', { placement: placement, people: input.people || 0, room_l: input.roomLengthFt, room_w: input.roomWidthFt, credenza: input.credenza, verdict: last.verdict, pick_ft: shopLength(last) || 0, pick: last.recommended ? String(last.recommended.h) : '' });
    }
    form.addEventListener('submit', run);
    // clicks on any table (or the contact button) inside the answer
    if (dialog) dialog.addEventListener('click', function (ev) {
      var a = ev.target.closest ? ev.target.closest('a[href]') : null;
      if (!a || !dialog.contains(a)) return;
      sendLog(logUrl, { event: 'click', placement: placement, path: location.pathname, vid: visitorId(), ts: new Date().toISOString(), href: a.getAttribute('href'), text: (a.textContent || '').trim().slice(0, 120), pick: last && last.recommended ? last.recommended.h : null });
      if (a.hasAttribute('data-os-calc-shop')) osTrack('calc_shop', { placement: placement, ft: Number(a.getAttribute('data-os-calc-shop')) || 0 });
    });
    var closers = section.querySelectorAll('[data-os-calc-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', function () { if (dialog) dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
    if (dialog) dialog.addEventListener('click', function (ev) { if (ev.target === dialog) dialog.close(); });
    // rail gallery: arrows cycle the conference-table photos
    var gal = section.querySelector('[data-os-calc-gallery]');
    if (gal) {
      var slides = gal.querySelectorAll('[data-os-calc-slide]');
      var cur = 0; for (var s0 = 0; s0 < slides.length; s0++) if (slides[s0].hasAttribute('data-os-calc-start')) cur = s0;
      var show = function (n) { for (var x = 0; x < slides.length; x++) slides[x].hidden = x !== n; cur = n; gal.setAttribute('aria-label', 'Conference table ' + (n + 1) + ' of ' + slides.length); };
      var prev = gal.querySelector('[data-os-calc-prev]'), next = gal.querySelector('[data-os-calc-next]');
      if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
      if (prev) prev.addEventListener('click', function () { show((cur - 1 + slides.length) % slides.length); });
      if (next) next.addEventListener('click', function () { show((cur + 1) % slides.length); });
      show(cur);
    }
    section.classList.add('os-calc--ready');
  }

  window.OSConferenceCalc = { RULES: RULES, compute: compute, renderText: renderText, lines: lines, seatPair: seatPair, lengthForSeats: lengthForSeats };
  if (typeof document !== 'undefined') {
    var boot = function () { var secs = document.querySelectorAll('[data-os-conference-calc]'); for (var i = 0; i < secs.length; i++) init(secs[i]); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  }
})();
